<template>
  <div class="home">欢迎 <span style="color:#409EFF">{{ adminName }}</span>  登录使用{{platformName}}~~~</div>
</template>

<script>
export default {
  name: "Home",
  components: {},
  data() {
    return {
      adminName: this.$store.getters.adminName,
      platformName: this.$store.getters.platformName,
    };
  },
};
</script>
<style lang="scss" scoped>
.home {
  padding: 30px;
}
</style>
